import React from 'react';
import {styled} from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, {tableCellClasses} from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Promo from "./Promo";

const StyledTableCell = styled(TableCell)(({theme}) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const PromoTable = ({promos}) => {


    return (
        <div>
            <Typography style={{marginLeft: "5vw", marginTop: "10px", width: '90vw'}} variant="h4" component="div" gutterBottom>Promo Codes</Typography>
            <TableContainer component={Paper} style={{margin: "auto", width: '90vw'}}>
                <Table sx={{minWidth: 700}} aria-label="customized table">
                    <TableHead
                        style={{backgroundColor: "darkgreen"}}>
                        <TableRow>
                            <StyledTableCell style={{width: '30vw'}}>Name</StyledTableCell>
                            <StyledTableCell style={{width: '20vw'}}>Code</StyledTableCell>
                            <StyledTableCell ></StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {promos.map((promo) => <Promo name={promo.fName +' '+promo.lName} code={promo.code}  guid={promo.guid}/>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>)
};


export default PromoTable;